import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_FloatLabel, {
      label: _ctx.$t(`w3_autocomplete.label`)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AutoComplete, {
          modelValue: _ctx.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event?.words || $event))),
          minLength: 2,
          suggestions: _ctx.suggestions,
          field: "words",
          onComplete: _ctx.search,
          onItemSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelect($event.value)))
        }, {
          item: _withCtx(({item}) => [
            _createElementVNode("strong", null, _toDisplayString(item.words), 1),
            (item.nearestPlace)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("i", null, _toDisplayString(item.nearestPlace), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "suggestions", "onComplete"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}